"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createShow: function() {
        return createShow;
    },
    deleteShow: function() {
        return deleteShow;
    },
    duplicateShow: function() {
        return duplicateShow;
    },
    generateShows: function() {
        return generateShows;
    },
    resetShows: function() {
        return resetShows;
    },
    updateShow: function() {
        return updateShow;
    }
});
const _types = /*#__PURE__*/ _interop_require_wildcard(require("./types/index.js"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function createShow(payload) {
    return {
        type: _types.ADD_SHOW,
        payload
    };
}
function duplicateShow(payload) {
    return {
        type: _types.DUPLICATE_SHOW,
        payload
    };
}
function updateShow(payload) {
    return {
        type: _types.UPDATE_SHOW,
        payload
    };
}
function deleteShow(payload) {
    return {
        type: _types.DELETE_SHOW,
        payload
    };
}
function resetShows() {
    return {
        type: _types.RESET_SHOWS
    };
}
function generateShows(payload) {
    return {
        type: _types.GENERATE_SHOWS,
        payload
    };
}
